import React, { useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Toolbar,
  ExcelExport,
  PdfExport,
  ColumnChooser,
} from '@syncfusion/ej2-react-grids';
// components
import has from 'lodash/has';
import toString from 'lodash/toString';

const SubAreasDataGrid = ({ data }) => {
  const toolbarOptions = ['ExcelExport', 'ColumnChooser', 'Search'];
  const ref = useRef();
  const toolbarClick = (args) => {
    switch (args.item.text) {
      case 'Excel Export':
        ref.current.excelExport();
        break;
      default:
        break;
    }
  };
  const params = useParams();

  // custom columns
  const idTemplate = (rowData) => {
    return (
      <div className="d-flex flex-column btns-column">
        <Link
          to={`/delivery/areas/${params?.id}/sub/${rowData.Id}/edit`}
          className="total-txt link area-link"
        >
          {parseInt(rowData.Id, 10)}
        </Link>
      </div>
    );
  };

  const nameTemplate = (rowData) => {
    return (
      <Link
        to={`/delivery/areas/${params?.id}/sub/${rowData.Id}/edit`}
        className="total-txt link area-link"
      >
        {rowData.Name}
      </Link>
    );
  };

  const nameArTemplate = (rowData) => {
    return (
      <Link
        to={`/delivery/areas/${params?.id}/sub/${rowData.Id}/edit`}
        className="total-txt link area-link"
      >
        {rowData.NameAr}
      </Link>
    );
  };

  const statusTemplate = (rowData) => {
    return (
      <button
        className={`btn generic-status ${
          rowData.IsActive ? 'btn-light-success' : 'btn-light-danger'
        }`}
      >
        {rowData.IsActive ? 'Active' : 'Inactive'}
      </button>
    );
  };

  const deliveryCostTemplate = (rowData) => {
    return <p className="total-txt">{rowData.DeliveryCost}</p>;
  };

  const zoneTemplate = (rowData) => {
    return <p className="total-txt">{rowData.Zone}</p>;
  };

  const excelQueryCellInfo = (args) => {
    if (has(args.column, 'customExcelTemplate')) {
      args.value = toString(args.column.customExcelTemplate(args.data));
    }
  };

  return (
    <div className="control-pane">
      <div className="control-section">
        <GridComponent
          dataSource={data}
          toolbar={toolbarOptions}
          allowExcelExport={true}
          excelQueryCellInfo={excelQueryCellInfo}
          ref={ref}
          toolbarClick={toolbarClick}
          allowTextWrap={true}
          showColumnChooser={true}
        >
          <ColumnsDirective>
            <ColumnDirective
              field="Id"
              headerText="ID"
              template={idTemplate}
              width={60}
              customExcelTemplate={(rowData) => rowData.Id}
            />
            <ColumnDirective
              field="Name"
              headerText="Name EN"
              template={nameTemplate}
              width={100}
              customExcelTemplate={(rowData) => rowData.Name}
            />
            <ColumnDirective
              field="NameAr"
              headerText="Name AR"
              template={nameArTemplate}
              width={100}
              customExcelTemplate={(rowData) => rowData.NameAr}
            />
            <ColumnDirective
              field="IsActive"
              headerText="Status"
              template={statusTemplate}
              width={100}
              customExcelTemplate={(rowData) => rowData.IsActive}
              customAttributes={{ class: 'area-status' }}
            />
            <ColumnDirective
              field="DeliveryCost"
              headerText="Delivery Price"
              template={deliveryCostTemplate}
              width={100}
              customExcelTemplate={(rowData) => rowData.DeliveryCost}
            />
            <ColumnDirective
              field="Zone"
              headerText="Zone"
              template={zoneTemplate}
              width={100}
              customExcelTemplate={(rowData) => rowData.Zone}
            />
          </ColumnsDirective>
          <Inject services={[Toolbar, ExcelExport, PdfExport, ColumnChooser]} />
        </GridComponent>
      </div>
    </div>
  );
};

export default React.memo(SubAreasDataGrid);
